<template>
	<div class="footer">
		<div class="tk wow slideInUp">联系邮箱：yicai0822@taikanglife.com</div>
		<div class="copyright wow slideInUp"><p>泰康保险集团版权所有</p><p>Copyright Taikanglife.All Rights Reserved | 京公网安备 11040102700049号 京ICP备09074081号-1 </p></div>
	</div>
</template>

<script>
	import ApiSetting from '../../assets/js/interface'
	export default {
		name: 'Footer',
		props: [],
		data() {
			return {

			};
		},
		components: {},
		mounted() {
			//动画初使化
			new this.$WOW.WOW({live: false}).init();
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	@import '../../assets/css/common';
</style>


// WEBPACK FOOTER //
// src/components/public/Footer.vue